import { useMemo } from "react";
import { Link } from "react-router";

import { ClothingWithImgData } from "../../data/clothing/clothing-with-img.data";
import * as styles from "./index.module.scss";

interface ClothingCardProps {
  clothing: ClothingWithImgData;
  storeId?: string;
}

export function ClothingCard({ clothing, storeId }: ClothingCardProps) {
  const clothingCover = useMemo(() => {
    if (clothing.coverImg) return clothing.coverImg;
    if (clothing.imgs.length < 1) return;

    return clothing.imgs[0];
  }, [clothing.coverImg, clothing.imgs]);

  const detailPath = storeId
    ? `/clothing/${clothing.id}?store=${storeId}`
    : `/clothing/${clothing.id}`;

  return (
    <Link to={detailPath} className={styles.clothingCard}>
      <div className={styles.clothingCardCover}>
        {!!clothingCover && (
          <img
            src={clothingCover.file.url}
            alt={clothing.name}
            loading="lazy"
          />
        )}
      </div>

      <div className={styles.clothingCardBody}>
        <h3 className={styles.clothingCardName}>{clothing.name}</h3>

        {!!clothing.description && (
          <p className={styles.clothingCardDescription}>
            {clothing.description}
          </p>
        )}
      </div>
    </Link>
  );
}
